<ng-template #PersonalInfoSkeleton>
    <div class="shine" style="width: 20%; height: 12px"></div>
    <div style="border-bottom: 1px dotted #c5c5c5; padding-bottom: 10px; margin-bottom: 30px">
        <div class="shine" style="width: 40%; height: 12px"></div>
    </div>
</ng-template>

@if (showLoading) {
    <div>
        <div class="personal-info">
            <div class="personal-info-body">
                <ng-template [ngTemplateOutlet]="PersonalInfoSkeleton"></ng-template>
                <ng-template [ngTemplateOutlet]="PersonalInfoSkeleton"></ng-template>
                <ng-template [ngTemplateOutlet]="PersonalInfoSkeleton"></ng-template>
                <ng-template [ngTemplateOutlet]="PersonalInfoSkeleton"></ng-template>
                <ng-template [ngTemplateOutlet]="PersonalInfoSkeleton"></ng-template>
            </div>
        </div>
    </div>
}
@if (!showLoading) {
    <div>
        <div class="personal-info">
            <form name="personalInfoForm" [formGroup]="personalInfoForm">
                <div class="personal-info-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field>
                                <mat-label>Name</mat-label>
                                <input type="text" matInput formControlName="name" required />
                                <img
                                    class="edit-icon"
                                    src="{{ DEPLOY_URL }}/assets/images/edit_pen_black.svg"
                                    matTextSuffix
                                    appToggleInput
                                    [form]="personalInfoForm"
                                    [field]="'name'"
                                    [update]="isFormUpdated"
                                    alt="" />
                                @if (f.name.touched && f.name.errors?.required) {
                                    <mat-error> Name is required </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field>
                                <mat-label>Phone No.</mat-label>
                                <input
                                    type="number"
                                    inputmode="numeric"
                                    matInput
                                    formControlName="phone_no"
                                    placeholder="Phone No." />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field>
                                <mat-label>Email</mat-label>
                                <input type="email" inputmode="email" matInput formControlName="email" required />
                                <img
                                    class="edit-icon"
                                    src="{{ DEPLOY_URL }}/assets/images/edit_pen_black.svg"
                                    matTextSuffix
                                    appToggleInput
                                    [form]="personalInfoForm"
                                    [field]="'email'"
                                    [update]="isFormUpdated"
                                    alt="" />
                                @if (f.email.touched && f.email.errors?.required) {
                                    <mat-error> Email is Required </mat-error>
                                }
                                @if (f.email.touched && f.email.errors?.pattern) {
                                    <mat-error> Please enter valid Email Address </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field>
                                <mat-label>Password</mat-label>
                                <input
                                    type="password"
                                    inputmode="password"
                                    matInput
                                    formControlName="password"
                                    required
                                    style="width: 50%" />
                                <div matTextSuffix class="update-password-link">
                                    <a href="JavaScript:void(0);" (click)="showUpdatePasswordModal()"> Change </a>
                                </div>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <mat-form-field>
                                <mat-label>DOB</mat-label>
                                <input
                                    inputmode="date"
                                    matInput
                                    formControlName="birthday"
                                    required
                                    [max]="todayDate"
                                    [matDatepicker]="picker"
                                    readonly />
                                <div matTextSuffix style="display: flex; align-items: center">
                                    <mat-datepicker-toggle matSuffix [for]="picker" class="calendar-icon">
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                    <img
                                        class="edit-icon"
                                        src="{{ DEPLOY_URL }}/assets/images/edit_pen_black.svg"
                                        appToggleInput
                                        [form]="personalInfoForm"
                                        [field]="'birthday'"
                                        [update]="isFormUpdated"
                                        alt="" />
                                </div>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <div class="space-10"></div>
                            <div class="clearfix"></div>
                            @if (showSubmitButton) {
                                <button
                                    btn-border
                                    class="pull-right"
                                    [disabled]="isFormDisabled"
                                    (click)="updateCustomer(personalInfoForm.value)">
                                    Update
                                </button>
                            }
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
}
